import Highcharts from 'highcharts';
import { getEmploymentData } from "./chart-salaries.js";

/**
 * @param {string} id
 */
export default function chartStructure(id) {
    if (!document.getElementById(id)) return;

    // Filter cities where we could calculate civilians
    const cityData = getEmploymentData()
        .filter(item => item.civilians !== null)
        .sort((a, b) => b.civilianRatio - a.civilianRatio);

    const categories = cityData.map(item => item.city);
    const guardsData = cityData.map(item => item.filledGuards); // Comparing filled to filled
    const civilianData = cityData.map(item => item.civilians);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Struktura zatrudnienia: Mundurowi vs Cywile' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Procentowy udział' },
            reversedStacks: false
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
        },
        plotOptions: {
            series: {
                stacking: 'percent',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.1f}%'
                }
            }
        },
        legend: {
            reversed: true
        },
        credits: { enabled: false },
        series: [{
            name: 'Pracownicy cywilni',
            data: civilianData,
            color: '#f1c40f'
        }, {
            name: 'Strażnicy miejscy',
            data: guardsData,
            color: '#2c3e50'
        }]
    });
}
